import axios from 'axios';

// const API_BASE_URL = 'http://localhost:8003';
const API_BASE_URL = 'https://newerpapi.wisdomsprouts.in/';


// const API_BASE_URL = 'http://api.sj-enterprises.in:8003';
// const API_BASE_URL = 'https://offerletter-backend-q26o.onrender.com';
// const API_BASE_URL = 'https://offerletter-backend.onrender.com';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient; 